import {http} from '@/services/http'
import type {BrandsResponse, TaxonomyValue} from './models'

export const fetchRebateBrands = async (): Promise<TaxonomyValue[]> => {
	const {data} = await http.get<BrandsResponse>(
		'/api/brands?params=rebate_brands'
	)

	if (!data.success) {
		throw new Error('Failed to fetch rebate brands')
	}

	return data.data
}
